exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.context {\n  background: white;\n  padding: 0;\n  margin: 0 16px;\n}\n", ""]);

// exports
